// The email invite an owner sends a directory vendor (Nov 2026). REDI sends
// nothing itself: this builds a mailto: link that opens the owner's own mail
// program with the opportunity link filled in, so the vendor hears from a
// person they can reply to, and a bid is how their address reaches the plan.

export interface VendorInviteInput {
  email: string;
  repName?: string;
  organization: string;
  bundleName: string;
  opportunityUrl: string;
  ownerName?: string;
}

function firstName(name: string | undefined): string | undefined {
  const first = name?.trim().split(/\s+/)[0];
  return first || undefined;
}

export function vendorInviteSubject(bundleName: string): string {
  return `Wildfire prep work you could bid on: ${bundleName}`;
}

export function vendorInviteBody({
  repName,
  organization,
  bundleName,
  opportunityUrl,
  ownerName,
}: Omit<VendorInviteInput, 'email'>): string {
  const greeting = firstName(repName) ? `Hi ${firstName(repName)},` : `Hello ${organization},`;
  const lines = [
    greeting,
    '',
    `I'm planning wildfire prep work (${bundleName}) and found ${organization} in the REDI vendor list. If you can help, this page shows the work and lets you send a price:`,
    '',
    opportunityUrl,
    '',
    'Thanks,',
  ];
  if (ownerName?.trim()) lines.push(ownerName.trim());
  return lines.join('\n');
}

/** mailto: with the subject and body encoded; '' when there's no address. */
export function vendorInviteMailto(input: VendorInviteInput): string {
  const email = input.email.trim();
  if (!email) return '';
  const params = `subject=${encodeURIComponent(vendorInviteSubject(input.bundleName))}&body=${encodeURIComponent(vendorInviteBody(input))}`;
  return `mailto:${encodeURIComponent(email).replace(/%40/g, '@')}?${params}`;
}
